import PageWrapper from 'components/utils/PageWrapper';
import ItemCreationWizard from 'pages/ItemCreationWizard';

export const itemCreationWizardRoutes = {
    path: '/item-creation-wizard',
    element: (
        <PageWrapper titleId="item_creation_wizard">
            <ItemCreationWizard />
        </PageWrapper>
    ),
};
